import axios from 'axios'
import { encode } from 'js-base64'
import sha1 from 'js-sha1'
import { getToken } from '@/utils'

const config = {
  baseURL: process.env.VUE_APP_HOST_URL,
  timeout: 60 * 1000
}

function getUUID () {
  if (localStorage.getItem('h5-app-uuid')) {
    return localStorage.getItem('h5-app-uuid')
  }
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  localStorage.setItem('h5-app-uuid', s.join(''))
  return s.join('')
}

const instance = axios.create(config)
const defaultHeaders = {
  'Content-Type': 'application/json',
  devicePlatform: 'wap',
  mebDeviceId: getUUID(),
  appid: process.env.VUE_APP_AKEY,
  nonce: '3343434'
}
instance.interceptors.request.use(
  function (config) {
    const timestamp = Math.round(Date.now() / 1000).toString()
    const paramsStr = config.params
    const splitParams = []
    for (const key in paramsStr) {
      splitParams.push(`${key}=${paramsStr[key]}`)
    }
    const arr = [`appid=${process.env.VUE_APP_AKEY}`, 'nonce=3343434', `timestamp=${timestamp}`]
    arr.push(...splitParams)
    arr.sort()
    const queryString =
      arr.join('&') +
      `&secret=${process.env.VUE_APP_SKEY}`
    const sha = sha1(queryString)
    config.headers.timestamp = timestamp
    config.headers.sigture = encode(sha)
    config.headers = Object.assign({}, config.headers, defaultHeaders)
    if (getToken()) {
      config.headers.token = getToken()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
instance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    const errors = Object.assign({}, error)
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          errors.message = '用户未登录'
          break
        case 500:
          errors.message = '出错啦'
          break
        case 405:
          errors.message = '请求方式错误'
          break
        case 404:
          errors.message = '请求接口不存在'
          break
        default:
          errors.message = '出错啦'
          break
      }
    } else {
      errors.message = '服务器无响应'
    }
    return Promise.reject(errors)
  }
)
export default instance
